/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeliveryEvent } from './deliveryEvent';


/**
 * What happened to one recipient\'s copy, as Flowmailer saw it, oldest first.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface RecipientDelivery { 
    address: string;
    events: Array<DeliveryEvent>;
}
export const RecipientDelivery_address_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const RecipientDelivery_events_Validators: ValidatorFn[] =
    [  Validators.required, ];


